const CashCollectionTypeEnum = Object.freeze({
	VGT_DROP: 'VgtDrop',
	RT_BV_DROP: 'RtBvDrop',
	RT_AUDIT: 'RtAudit',
});

export default CashCollectionTypeEnum;
